import { arrayOf, bool, func, shape, string } from 'prop-types';
import { NavLink } from 'react-router-dom';

import { Icon, Skeleton } from 'components';

const Breadcrumb = ({ breadcrumbItems, loading = false }) => {
  const renderCrumb = (crumb) => {
    if (crumb.url) {
      return (
        <NavLink to={crumb.url} className={({ isActive }) => (isActive ? 'text-gray-700' : 'text-gray-500')}>
          <span className="whitespace-nowrap">{crumb.label}</span>
        </NavLink>
      );
    } else if (crumb.button) {
      return crumb.button();
    } else {
      return <span className="text-gray-700 md:whitespace-nowrap max-w-80 md:max-w-none">{crumb.label}</span>;
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {loading ? (
        <Skeleton type="text" classNames="w-64 h-6" />
      ) : (
        <>
          {breadcrumbItems.map((crumb, index) => (
            <div key={`navlink-${crumb.id}-${index}`} className="flex items-center gap-2 shrink-0">
              {renderCrumb(crumb)}
              {index < breadcrumbItems.length - 1 && <Icon name="angle-right" classes="text-gray-500" />}
            </div>
          ))}
        </>
      )}
    </div>
  );
};

Breadcrumb.propTypes = {
  breadcrumbItems: arrayOf(
    shape({
      label: string,
      url: string,
      button: func
    })
  ).isRequired,
  loading: bool
};

export default Breadcrumb;
